import { ArrayMinSize, IsArray, IsDefined, IsNumber, IsOptional, IsString, IsUrl } from 'class-validator';
import { Type } from 'class-transformer';

export class ExtractReceiptDetailsBodyDto {
  @IsDefined()
  @IsUrl()
  url: string;

  @IsOptional()
  @IsArray()
  @ArrayMinSize(1)
  @IsString({ each: true })
  categories: string[];

  @IsOptional()
  @IsArray()
  @ArrayMinSize(1)
  @IsNumber({}, { each: true })
  @Type(() => Number)
  vatRates: number[];
}